import { render, staticRenderFns } from "./HireHistory.vue?vue&type=template&id=ba87fa34"
import script from "./HireHistory.vue?vue&type=script&lang=js"
export * from "./HireHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports